import React from 'react';
import 'moment/locale/pt';
import TableCollapse from '../../../../components/TableCollapse';

export default function CupomViewer({ goBack, cupons }) {
  
  const COLUMNSTABLE = [
    {
      headerName: 'Número',
      type: 'default',
      field: 'current_installment',
      sizeCell: 60
    },
    {
      headerName: 'Status',
      type: 'default',
      field: 'status',
      sizeCell: 100

    },
    {
      headerName: 'Valor do cupom',
      type: 'money',
      field: 'amount_cpr_installment',
      sizeCell: 150


    },
    {
      headerName: 'Valor dos juros',
      type: 'money',
      field: 'amount_cpr_profit',
      sizeCell: 150

    },
    {
      headerName: 'Data inicial',
      type: 'date',
      field: 'date_start',
      sizeCell: 100

    },
    {
      headerName: 'Data final',
      type: 'date',
      field: 'date_end',
      sizeCell: 100

    },
    {
      headerName: 'Dias úteis',
      type: 'default',
      field: 'business_day',
      sizeCell: 80

    },
    {
      headerName: 'Atualizado em',
      type: 'timedate',
      field: 'updated_at',
      sizeCell: 120

    },
    {
      headerName: 'Pago em',
      type: 'timedate',
      field: 'payment_date',
      noData: 'Pendente',
      sizeCell: 120

    },
    {
      headerName: 'Usuário',
      type: 'default',
      field: 'username',
      sizeCell: 120

    }
  ]

  const actions = [
  ]

  return (
    <div>
      <h4 style={{ marginTop: 10, marginLeft: 10 }}>Cupons</h4>
      <div>
        <TableCollapse 
          data={cupons}
          columns={COLUMNSTABLE}
          actions={actions}
        />
      </div>
    </div>
  )
}